import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import notImage from "../images/not-image.jpg";
import useProducts from "../hooks/useProducts";
import clsx from "clsx";
import { useSearchParams } from "react-router-dom";
import useAxios from "../hooks/useAxios";

const ParentProductModal = ({ data, setData, name, defaultValue }) => {

    const [searchParams] = useSearchParams();

    const [currentValue, setCurrentValue] = useState(null);

    const [show, setShow] = useState(false);

    const [currentProducts, setCurrentProducts] = useState([]);

    const [filters, setFilters] = useState({
        perPage: 10,
        page: 1,
        parentsOnly: true,
        name: ''
    });

    const [{ products, numberOfPages, loading }, getProducts] = useProducts({ params: filters }, { useCache: false });

    const [{ loading: findParentLoading }, findParent] = useAxios({ manual: true, useCache: false });

    useEffect(() => {
        if (defaultValue) setCurrentValue(defaultValue);
    }, [defaultValue])

    useEffect(() => {
        setCurrentProducts((old) => [...old, ...products]);
    }, [products])

    useEffect(() => {
        const productParentId = searchParams?.get('parentId');
        if (productParentId) {
            findParent({ url: `/products/${productParentId}` }).then((response) => {
                const parentData = response?.data?.data;
                setCurrentValue(parentData);
                setData((oldData) => {
                    return {
                        ...oldData,
                        parentId: parentData?.id
                    }
                })
            });
        }
    }, [searchParams])

    const handleProduct = (product) => {
        setCurrentValue(product);
        setData((oldData) => {
            return {
                ...oldData,
                [name]: product?.id
            }
        });
        setShow(false);
    }

    const handleRemove = () => {
        setCurrentValue(null);
        setData((oldData) => {
            return {
                ...oldData,
                [name]: null
            }
        });
    }

    return (
        <>
            <h5>Producto padre</h5>
            {
                !currentValue ?
                    <>
                        <p className="mb-3">
                            Escoja un producto padre si este es una version de otro producto.
                        </p>
                        <button type="button" onClick={() => setShow(true)} className="btn btn-success">Añadir</button>
                    </>
                    :
                    <ul class="list-group col-md-12 mb-3" style={{ maxHeight: 300, overflow: 'auto' }}>
                        <li class="list-group-item">
                            <div className="d-flex gap-2 align-items-center">
                                <img
                                    src={currentValue?.imagePath || currentValue?.image_path || notImage}
                                    className="rounded-circle"
                                    style={{ height: 50, width: 50, objectFit: 'cover' }}
                                    alt={currentValue?.name}
                                />
                                <div>
                                    <p className="mb-0">
                                        {currentValue?.name}
                                    </p>
                                    <p className="mb-0 text-primary">
                                        {currentValue?.category?.path}
                                    </p>
                                </div>
                                <div style={{ marginLeft: 'auto' }}>
                                    <button type="button" onClick={() => setShow(true)} className="btn btn-primary">
                                        <i className="fa fa-edit"></i>
                                    </button>
                                </div>
                                <div>
                                    <button type="button" onClick={handleRemove} className="btn btn-danger">
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>

            }
            <Modal show={show} className="fade" size="lg">
                <Modal.Header>
                    <Modal.Title>Productos</Modal.Title>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setShow(false)}
                    >
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            placeholder="Escriba el nombre..."
                            className="form-control mb-3"
                            value={filters?.name}
                            type="text"
                            onChange={(e) => {
                                setCurrentProducts([]);
                                setFilters((oldFilters) => {
                                    return {
                                        ...oldFilters,
                                        name: e.target.value,
                                        page: 1
                                    }
                                })
                            }}
                        />
                    </div>
                    <ul class="list-group col-md-12 mb-3" style={{ maxHeight: 300, overflow: 'auto' }}>
                        {
                            currentProducts?.map((product) => {
                                return (
                                    <li
                                        onClick={() => handleProduct(product)}
                                        class={clsx(["list-group-item product-option"], {
                                            'product-option-active': currentValue?.id === product?.id
                                        })}

                                        key={`product-${product?.id}`}
                                    >
                                        <div className="d-flex gap-2 align-items-center">
                                            <img
                                                src={product?.imagePath || notImage}
                                                className="rounded-circle"
                                                style={{ height: 50, width: 50, objectFit: 'cover' }}
                                                alt={product?.name}
                                            />
                                            <div>
                                                <p className="mb-0">
                                                    {product?.name}
                                                </p>
                                                <p className="mb-0 text-primary category-name">
                                                    {product?.category?.path}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                        }
                        {
                            !loading && currentProducts?.length < 1 ?
                                <li class="list-group-item text-center">
                                    No se encontrarón resultados.
                                </li>
                                :
                                null
                        }
                        {
                            loading ?
                                <li class="list-group-item text-center">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </li>
                                :
                                null
                        }
                        {
                            !loading && numberOfPages > filters?.page ?
                                <li class="list-group-item text-center">
                                    <button
                                        onClick={() => setFilters((old) => ({ ...old, page: old?.page + 1 }))}
                                        type="button"
                                        className="btn btn-primary"
                                    >
                                        Cargar más
                                    </button>
                                </li>
                                :
                                null
                        }
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={() => { setShow(false) }} className="btn btn-danger">
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ParentProductModal;